import React, { useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { Button } from 'react-bootstrap5';
import Modal from 'components/new_ui/Modal/Modal';

import routes from 'app/routes';

export default function ChooseCreateType({ enterpriseId }) {
  const [show, setShow] = useState(true);
  const [loading, setLoading] = useState(false);

  const onChoose = (actionType) => {
    setLoading(true);
    axios
      .get(
        routes.api.enterprises.choose_create_enterprise,
        { params: { action_type: actionType, enterprise_id: enterpriseId } },
      )
      .then((_resp) => {
        setLoading(false);
        setShow(false);
      });
  };

  return (
    <Modal show={show}>
      <p>We&apos;ve found a matching enterprise account.</p>
      <p> If you want to link your team to the same account, click the Link button.</p>
      <p> Or click the Add New button to create a different account for your enterprise.</p>
      <div className="d-flex justify-content-center gap-2">
        <Button
          variant="outline-primary"
          onClick={() => onChoose('create-new')}
          className="button-no"
          style={{ width: '180px' }}
          disabled={loading}
        >
          {loading ? 'Add New... ' : 'Add New'}
        </Button>
        <Button
          onClick={() => onChoose('choose-exist')}
          className="button-yes"
          style={{ width: '180px' }}
          disabled={loading}
        >
          {loading ? 'Link... ' : 'Link'}
        </Button>
      </div>
    </Modal>
  );
}

ChooseCreateType.propTypes = {
  enterpriseId: PropTypes.number.isRequired,
};
